module.exports = __webpack_public_path__ + "static/media/slick.7ba97953.svg";